import React, {useState, useRef, useEffect} from 'react'
import deleteIcon from '../../../../../_metronic/images/Trashdelete.svg'
import uploadIcon from '../../../../../_metronic/images/upload.svg'
import plusIcon from '../../../../../_metronic/images/smlplus-blue.svg'
import {FormikProvider, FieldArray} from 'formik'
import {Stack} from 'react-bootstrap'

import Dropdown from '../../../../sharedComponent/Dropdown/Dropdown'
import UploadCSV from '../../../../sharedComponent/UploadCSV'
import UploadAgentCSV from '../../../../sharedComponent/UploadAgentCSV'
import {DownloadTemplate} from '../../../../sharedComponent/DownloadTemplate/DownloadTemplate'

const AddAgent = ({formik}: any) => {
  const [manualAgent, setManualAgent] = useState(true)
  const [fileUploadErr, setFileUploadErr] = useState(false)
  const scrollEndRef = useRef<null | HTMLDivElement>(null)
  const filterEmptyAgents = (agents: any) => {
    return agents.filter(
      (agent: any) =>
        agent.agentFirstName || agent.agentLastName || agent.agentEmailID || agent.agentLeaderCode
    )
  }
  return (
    <div>
      <FormikProvider value={formik}>
        <div className='container'>
          <FieldArray name='agent'>
            {({form: {values, setValues, validateForm}, ...fieldArrayHelpers}) => {
              const onAddClick = (e: any) => {
                e.preventDefault()
                fieldArrayHelpers.push({
                  id: values?.agent?.length,
                  agentFirstName: '',
                  agentLastName: '',
                  agentEmailID: '',
                  agentLeaderCode: null,
                })
              }
              const onBulkUpload = (e: any) => {
                setManualAgent(false)
                formik.setErrors({})
                e.preventDefault()
              }
              const makeManualView = (e: any) => {
                const filteredAgents = filterEmptyAgents(formik.values.agent)
                formik.setFieldValue('agent', filteredAgents)
                e.preventDefault()
                setManualAgent(true)
              }
              return (
                <React.Fragment>
                  <div>
                    <Stack direction='horizontal' gap={3}>
                      <div>
                        <h1 className='text-gray-800 fs-3'>Agent List </h1>
                      </div>

                      <div className='ms-auto'>
                        <DownloadTemplate
                          href={process.env.REACT_APP_AGENT_TEMPLATE_DOWNLOAD}
                          text='Download Template'
                        />

                        <button
                          className='btn btn-light-primary btn-active-light-primary ms-4'
                          onClick={(e: any) => onBulkUpload(e)}
                        >
                          {' '}
                          <img src={uploadIcon} alt='' className='svg-icon svg-icon-1' />
                          <span className='fw-bold fs-base'>Upload List</span>
                        </button>
                      </div>

                      {manualAgent ? (
                        <button
                          type='button'
                          className='btn btn-light-primary btn-active-light-primary'
                          onMouseDown={(e: any) => onAddClick(e)}
                          onClick={() => {
                            scrollEndRef.current?.scrollIntoView({behavior: 'smooth'})
                          }}
                        >
                          <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
                          <span className='fw-bold fs-base'>Add Agent</span>
                        </button>
                      ) : (
                        <button
                          type='button'
                          className='btn btn-light-primary btn-active-light-primary'
                          onClick={(e: any) => makeManualView(e)}
                        >
                          <img src={plusIcon} alt='' className='svg-icon svg-icon-1' />
                          <span className='fw-bold fs-base'>Add Agent</span>
                        </button>
                      )}
                    </Stack>
                  </div>
                  {manualAgent ? (
                    <div className='hover-scroll-overlay-y h-300px'>
                      <Stack
                        direction='horizontal'
                        className='d-flex justify-content-left align-items-center agent-header'
                      >
                        <div>
                          <h6 className='fs-7 fw-semibold lh-23px'>Agent First Name</h6>
                        </div>
                        <div>
                          <span className='fs-7 fw-semibold lh-23px'>Agent Last Name</span>
                        </div>
                        <div>
                          <span className='fs-7 fw-semibold lh-23px'>Agent Email ID</span>
                        </div>
                        <div>
                          <span className='fs-7 fw-semibold lh-23px'>Agent Leader Code</span>
                        </div>
                      </Stack>

                      {values?.agent?.map(({id}: any, index: any) => (
                        <div>
                          <Stack direction='horizontal' gap={2} className='pb-5'>
                            <div className='w-100 position-relative'>
                              <input
                                id={id}
                                name={`agent.[${index}].agentFirstName`}
                                className='form-control form-control-lg form-control-solid'
                                {...formik.getFieldProps(`agent.[${index}].agentFirstName`)}
                                value={formik.values.agent[index].agentFirstName}
                                onChange={formik.handleChange}
                                placeholder='Enter first name'
                              />
                              <span className='text-danger position-absolute '>
                                {Boolean(formik.errors?.agent) &&
                                  Boolean(formik.touched?.agent) &&
                                  formik.touched.agent[index] &&
                                  formik.errors?.agent[index]?.agentFirstName}
                              </span>
                            </div>
                            <div className='w-100 position-relative'>
                              <input
                                id={id}
                                name={`agent.[${index}].agentLastName`}
                                className='form-control form-control-lg form-control-solid'
                                {...formik.getFieldProps(`agent.[${index}].agentLastName`)}
                                value={formik.values.agent[index].agentLastName}
                                onChange={formik.handleChange}
                                placeholder='Enter last name'
                              />

                              <span className='text-danger position-absolute'>
                                {Boolean(formik.errors?.agent) &&
                                  Boolean(formik.touched?.agent) &&
                                  formik.touched.agent[index] &&
                                  formik.errors?.agent[index]?.agentLastName}
                              </span>
                            </div>
                            <div className='w-100 position-relative'>
                              <input
                                id={id}
                                name={`agent.[${index}].agentEmailID`}
                                className='form-control form-control-lg form-control-solid'
                                value={formik.values.agent[index].agentEmailID}
                                {...formik.getFieldProps(`agent.[${index}].agentEmailID`)}
                                onChange={formik.handleChange}
                                placeholder='Enter Email ID'
                              />
                              <span className='text-danger position-absolute'>
                                {Boolean(formik.errors?.agent) &&
                                  Boolean(formik.touched?.agent) &&
                                  formik.touched.agent[index] &&
                                  formik.errors?.agent[index]?.agentEmailID}
                              </span>
                            </div>

                            <div className='w-100 '>
                              <Dropdown
                                fieldName={`agent.[${index}].agentLeaderCode`}
                                optionList={formik.values?.agentLeaders?.map((leader: any) => ({
                                  id: leader.leaderCode,
                                  value: leader.leaderCode,
                                }))}
                                formik={formik}
                                selectedVal={formik.values.agent[index].agentLeaderCode}
                                handleSelectedItem={(e: any, fieldName: any) =>
                                  formik.setFieldValue(`agent.[${index}].agentLeaderCode`, e.value)
                                }
                              />
                            </div>

                            <button
                              type='button'
                              className='btn p-0'
                              onClick={() => fieldArrayHelpers.remove(index)}
                            >
                              <img src={deleteIcon} alt='delete icon' />
                            </button>
                          </Stack>
                          <Stack direction='horizontal' key={index} gap={1} className='mb-1'>
                            {formik.errors.agent && formik.touched.agent ? (
                              <div
                                data-field='appname'
                                data-validator='notEmpty'
                                className='fv-help-block text-danger'
                                style={{width: '30%'}}
                              ></div>
                            ) : (
                              <div
                                data-field='appname'
                                data-validator='notEmpty'
                                className='fv-help-block text-danger visibility-hidden'
                                style={{width: '30%'}}
                              >
                                {' '}
                              </div>
                            )}
                          </Stack>
                        </div>
                      ))}
                      <div
                        style={{float: 'left', clear: 'both'}}
                        ref={scrollEndRef}
                        className='mt-n3'
                      />
                    </div>
                  ) : (
                    <UploadAgentCSV
                      setFileUploadErr={setFileUploadErr}
                      fileUploadErr={fileUploadErr}
                      arrayHelpers={fieldArrayHelpers}
                    />
                  )}
                </React.Fragment>
              )
            }}
          </FieldArray>
        </div>
      </FormikProvider>
    </div>
  )
}
export default AddAgent
